export default {
  methods: {
    setContainerHeight () {
      const navbar = document.getElementById('navbar');
      const breadcrumb = document.getElementById('breadcrumb');
      if (navbar) {
        let navbarHeight = navbar.offsetHeight;
        let breadcrumbHeight = breadcrumb.offsetHeight;
        let bodyHeight = document.body.offsetHeight;
        let container = document.getElementById('container');
        if (container) {
          container.style.height = `${bodyHeight - navbarHeight - breadcrumbHeight}px`;
        }
      }
    }
  },
  mounted: function () {
    this.setContainerHeight();
  }
}